import * as React from "react";
import type { SVGProps } from "react";

const SvgBreadCrumbArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} className={`w-3 h-3 ${props.className}`}>
    <path d="M1.3999 0.799805L4.5999 3.9998L1.3999 7.1998" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SvgBreadCrumbArrow;